module.exports = __webpack_public_path__ + "static/media/selected-resume.5c7d5aa6.png";